import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<'primary' | 'secondary' | 'tertiary' | 'goGreen' | 'inherit'>
}>

/**
 * Caption1
 *
 * Demos:
 * - [Caption1](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-typography--docs)
 *
 */

export const Caption1 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="caption1" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
